/**
 * Hack fix for un-guided masks not allowing backspace on masked chars
 * See: https://github.com/text-mask/text-mask/issues/483#issuecomment-337259727
 * Since this package is no longer maintained, don't use this for anything new.
 * @param {*} mask The mask array
 * @param {*} nonCharactersList Index of masked chars
 */
const maskMaker = (mask = [], nonCharactersList = []) => {
  return raw => {
    const length = raw.length
    const nonDefault = nonCharactersList.some(characterIndex => {
      return characterIndex === length
    })
    return nonDefault ? mask.slice(0, length) : mask
  }
}

export const creditCardMask = maskMaker(
  [
    /[1-9]/,
    /\d/,
    /\d/,
    /\d/,
    ' ',
    /\d/,
    /\d/,
    /\d/,
    /\d/,
    ' ',
    /\d/,
    /\d/,
    /\d/,
    /\d/,
    ' ',
    /\d/,
    /\d/,
    /\d/,
    /\d/,
  ],
  [4, 9, 14],
)

export const expDateMask = [/\d/, /\d/, '/', /\d/, /\d/]
export const cvvMask = [/\d/, /\d/, /\d/, /\d/]
export const zipCodeMask = [/\d/, /\d/, /\d/, /\d/, /\d/]
